import React from 'react';
import UiContent from '../../../Components/Common/UiContent';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import { Container } from 'reactstrap';
import WarehouseList from './WarehouseList';

//redux

const Warehouses = () => {
	const breadcrumbLinks = [
		{ to: '#', label: 'Inicio', icon: 'icon-house' },
		{ to: '#', label: 'Empresa', icon: 'icon-building-2' },
	];

	return (
		<React.Fragment>
			<UiContent />
			<div className='page-content'>
				<Container fluid>
					<BreadCrumb title='Bodega' links={breadcrumbLinks} icon={'icon-warehouse'} />
					<WarehouseList/>
				</Container>
			</div>
		</React.Fragment>
	);
};

export default Warehouses;
